// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Cuttable';



// WEBPACK FOOTER //
// ./components/Cuttable/index.js